module.exports = __webpack_public_path__ + "media/images/sp/specials/common/special_c_13-ec2ac3c8edf361f3e405bb618cff8dcb.jpg";